// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","678":"component---src-pages-index-js"}[chunkId] + "-" + {"218":"376a2fa2105a434f3d14","678":"3d7755cd0017e82a362b"}[chunkId] + ".js";
};